var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForestOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:forest-outline",
    clipPath: "url(#clip0_2090_3720)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.521 22.1114H29.2218L24.647 15.0003H26.8514L18.5551 3.14844L15.7225 7.18992L22.0159 16.1855H19.7048L23.521 22.1114ZM19.7403 15.0003L11.444 3.14844L3.14771 15.0003H5.35216L0.777344 22.1114H9.07364V26.8521H13.8144V22.1114H22.1107L17.5359 15.0003H19.7403ZM15.1892 12.6299H13.2218L17.7729 19.741H5.12697L9.70179 12.6299H7.69883L11.444 7.29659L15.1892 12.6299ZM16.1848 23.2966V26.8521H20.9255V23.2966H16.1848Z",
    fill: "#2D5638"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2090_3720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.4444,
    height: 28.4444,
    fill: "white",
    transform: "translate(0.777344 0.777344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForestOutline);
export default __webpack_public_path__ + "static/media/forest-outline.bb7bc0d5c6360876497b629b285d20c0.svg";
export { ForwardRef as ReactComponent };